// Ephemeral client-side registry of "this surface has unsaved edits" flags
// (BL-758 AC 10). Programmatic navigators that bypass the DOM (the Sidebar's
// router.push buttons) can't be caught by anchor
// interception, so they consult this registry before navigating and show
// their own discard confirmation. Armed/disarmed by useUnsavedChangesGuard;
// a counter (not a boolean) tolerates multiple dirty surfaces at once.

let armedCount = 0;

/** Register one dirty surface. Pair every call with disarmUnsavedChanges. */
export function armUnsavedChanges(): void {
  armedCount += 1;
}

/** Release one dirty surface (floored at zero for unmount races). */
export function disarmUnsavedChanges(): void {
  armedCount = Math.max(0, armedCount - 1);
}

/** True while any mounted surface holds unsaved edits. */
export function hasUnsavedChanges(): boolean {
  return armedCount > 0;
}
